import sermorelin from './initial/flow';
import sermorelinFollowup from './followup/flow';
import metabolicTadalafil from './Tadalafil/initial/flow';
import metabolicTadalafilFollowup from './Tadalafil/followup/flow';
import metabolicMorlinConsent from './SermOnlyConsent/flows';

const sermorelinFlows = {
  sermorelin,
  sermorelinFollowup,
  metabolicMorlinConsent,
  metabolicTadalafil,
  metabolicTadalafilFollowup
};

export default sermorelinFlows;
